import React from "react";
import { Redirect } from "react-router-dom";

import dashboardRoutes from "./views/dashboard/DashboardRoutes";
import sessionRoutes from "./views/sessions/SessionRoutes";

import registerRoutes from "./views/Register/RegisterRoutes";
import adminRegisterRoutes from "./views/AdminRegister/AdminRegisterRoutes";
import resetPasswordRoutes from "./views/ResetPassword/ResetPasswordRoutes";
import newApplicationRoutes from "./views/NewApplication/NewApplicationRoutes";
import viewAppointmentRoutes from "./views/ViewAppointments/ViewAppointmentRoutes";
import viewAppointmentSingleRoutes from "./views/ViewAppointmentSingle/ViewAppointmentSingleRoutes";
import viewApplicationRoutes from "./views/ViewApplications/ViewApplicationRoutes";
import viewApplicationSingleRoutes from "./views/ViewApplicationsSingle/ViewApplicationsSingleRoutes";
import userProfileRoutes from "./views/UserProfile/UserProfileRoutes";
import newApplicationOfficerRoutes from "./views/NewApplicationOfficer/NewApplicationOfficerRoutes";
import receivedApplicationsRoutes from "./views/RecievedApplications/RecievedApplicationsRoutes";
import archivedApplicationsRoutes from "./views/ArchivedApplications/ArchivedApplicationsRoutes";
import viewPostedApplicationsRoutes from "./views/ViewPostedApplications/ViewPostedApplicationsRoutes";
import viewPostedApplicationSingleRoutes from "./views/ViewPostedApplicationSingle/ViewPostedApplicationSingleRoutes";
import viewRecievedApplicationSingleRoutes from "./views/ViewRecievedApplicationSingle/ViewRecievedApplicationSingleRoutes";
import dailyReportRoutes from "./views/DailyReport/DailyReportRoutes";
import updateApplicationRoutes from "./views/UpdateApplication/UpdateApplicationRoutes";
import allReportRoutes from "./views/AllReport/AllReportRoutes";
import dailyAccountReportRoutes from "./views/DailyAccountReport/DailyAccountReportRoutes";
import dailyMailReportRoutes from "./views/DailyMailReport/DailyMailReportRoutes";
import dailyCounterReportRoutes from "./views/DailyCounterReport/DailyCounterReportRoutes";
import DIEReportRoutes from "./views/DIEReport/DIEReportRoutes";
import DMTReportRoutes from "./views/DMTReport/DMTReportRoutes";
import PHReportRoutes from "./views/PHReport/PHReportRoutes";
import CRTReportRoutes from "./views/CRTReport/CRTReportRoutes";
import updateDocumentTypeRoutes from "./views/UpdateDocumentType/UpdateDocumentTypeRoutes";
import addNewSubDocumentTypeRoutes from "./views/AddNewSubDocumentType/AddNewSubDocumentTypeRoutes";
import updateSubDocumentTypeRoutes from "./views/UpdateSubDocumentType/UpdateSubDocumentTypeRoutes";
import createStatusGroupRoutes from "./views/CreateStatusGroup/CreateStatusGroupRoutes";
import assignStatusRoutes from "./views/AssignStatus/AssignStatusRoutes";
import updateStatusRoutes from "./views/UpdateStatus/UpdateStatusRoutes";
import createAmountTypeRoutes from "./views/CreateAmountType/CreateAmountTypeRoutes";
import disableSchedulingDatesRoutes from "./views/DisableSchedulingDates/DisableSchedulingDatesRoutes";
import userManagementRoutes from "./views/UserManagement/UserManagementRoutes";
import updateEmailsRoutes from "./views/UpdateEmails/UpdateEmailsRoutes";
import updateEmailSingleRoutes from "./views/UpdateEmailSingle/UpdateEmailSingleRoutes";
import updateLettersRoutes from "./views/UpdateLetters/UpdateLettersRoutes";
import updateLetterSingleRoutes from "./views/UpdateLetterSingle/UpdateLetterSingleRoutes";
import revokeAppointmentsRoutes from "./views/RevokeAppointments/RevokeAppointmentsRoutes";
import revokeApplicationsSingleRoutes from "./views/RevokeApplicationsSingle/RevokeApplicationsSingleRoutes";
import createStatusRoutes from "./views/CreateStatus/CreateStatusRoutes";
import appointmentReportRoutes from "./views/AppointmentReport/AppointmentReportRoutes";
import removeUsersRoutes from "./views/RemoveUsers/RemoveUsersRoutes";


const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard/analytics" />
  }
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />
  }
];

const routes = [
  ...sessionRoutes,
  ...registerRoutes,
  ...adminRegisterRoutes,
  ...resetPasswordRoutes,
  ...newApplicationRoutes, 
  ...viewAppointmentRoutes,
  ...viewAppointmentSingleRoutes,
  ...viewApplicationRoutes,
  ...viewApplicationSingleRoutes,
  ...userProfileRoutes,
  ...newApplicationOfficerRoutes,
  ...receivedApplicationsRoutes,
  ...archivedApplicationsRoutes,
  ...viewPostedApplicationsRoutes,
  ...viewRecievedApplicationSingleRoutes,
  ...viewPostedApplicationSingleRoutes,
  ...dailyReportRoutes,
  ...updateApplicationRoutes,
  ...allReportRoutes,
  ...dailyAccountReportRoutes,
  ...dailyMailReportRoutes,
  ...dailyCounterReportRoutes,
  ...DIEReportRoutes,
  ...DMTReportRoutes,
  ...PHReportRoutes,
  ...CRTReportRoutes,
  ...updateDocumentTypeRoutes,
  ...addNewSubDocumentTypeRoutes,
  ...updateSubDocumentTypeRoutes,
  ...createStatusGroupRoutes,
  ...assignStatusRoutes,
  ...updateStatusRoutes,
  ...createAmountTypeRoutes,
  ...disableSchedulingDatesRoutes,
  ...userManagementRoutes,
  ...updateEmailsRoutes,
  ...updateLettersRoutes,
  ...updateEmailSingleRoutes,
  ...updateLetterSingleRoutes,
  ...revokeAppointmentsRoutes,
  ...revokeApplicationsSingleRoutes,
  ...createStatusRoutes,
  ...appointmentReportRoutes,
  ...removeUsersRoutes,
  ...dashboardRoutes,
  ...redirectRoute,
  ...errorRoute
];

export default routes;
